export enum ConsoFamilyEnum {
    credit = 'credit',
    credit_2 = 'credit_2',
    error = 'error',
    compteRechargeable = 'compteRechargeable',
    internetMobile = 'internetMobile',
    communicationsPayantes = 'communicationsPayantes',
}
